export function header() {
  const header = $('.header');
  const logo = $('.header-logo-img');

  $(window).on('load scroll', function () {
    if (!header.hasClass('headeron')) {
      if ($(this).scrollTop() ?? 0 > 0) {
        header.addClass('on');
        logo.attr({ src: '/common/img/logo/green.svg' });
      } else {
        header.removeClass('on');
        logo.attr({ src: '/common/img/logo/white.svg' });
      }
    }
  });
}
